module.exports = __webpack_public_path__ + "img/CM-JN-24-Chevy-Playful.1a0ef48a.jpg";